import { useQuery } from "@tanstack/react-query";
import { getTransactions } from "../services/transactions";

export function useTransactions(options = {}) {

    const outletUid = localStorage.getItem(

        "selectedOutletUid"

    );

    return useQuery({

        queryKey: [

            "transactions",

            outletUid,

        ],

        queryFn: () =>

            getTransactions(

                outletUid

            ),

        enabled: !!outletUid,

        staleTime: 1000 * 60 * 5,

        ...options,

    });

}